module.exports = __webpack_public_path__ + "img/error-banner.07bc9c5.jpg";